import gql from 'graphql-tag'

export const home = gql`
 query home($locale: SiteLocale) {
  home(locale: $locale) {
    seo {
        title
        image {
          url
        }
        description
      }
      title
      subtitle
      videoHd
      video720
      video540
      video360
      paragraph
      iconTabs {
        svg {
          url
        }
        text
      }
      introImpianto
      textImpianto  
      coverDesk {
        responsiveImage {
          src
          srcSet
        }
      }
      coverMobile {
        responsiveImage {
          src
          srcSet
        }
      }
      imageImpiantoDesk {
        responsiveImage {
          src
          srcSet
        }
      }
      imageImpiantoMobile {
        responsiveImage {
          src
          srcSet
        }
      }
      introBiochar
      textBiochar 
      imageBiocharDesk {
        responsiveImage {
          src
          srcSet
        }
      }
      imageBiocharMobile {
        responsiveImage {
          src
          srcSet
        }
      }
    }
  }
`
